import http from '@/http'
import requestUrlFunction from '@/utils/requestUrl'

export default {
  namespaced: true,
  actions: {
    async createOrderComment(context, { id, content }) {
      const response = await http.post(`order/${id}/comment`, {
        content: content,
      })

      return response
    },
    async updateOrderStatus(context, { id, status }) {
      const response = await http.put(`order/${id}/status?status=${status}`)

      return response
    },
    async getOrderStatuses() {
      const response = await http.get(`order/status`)

      return response
    },
    async getOrderTransitionStatuses(context, id) {
      const response = await http.get(`order/${id}/status/transition`)

      return response
    },
    async transferOrder(context, { id, customerId }) {
      const response = await http.post(`order/${id}/transfer`, {
        customerId: customerId,
      })

      return response
    },
    async sendNotification(context, { id, type, channel }) {
      const response = await http.post(`order/${id}/notification?type=${type}&channel=${channel}`)

      return response
    },
    async getOrderNotifications(context, { id, channel }) {
      const response = await http.get(`order/${id}/notification?channel=${channel}`)

      return response
    },
    async getOrder(context, id) {
      const response = await http.get(`order/${id}`)

      return response
    },
    async deleteOrder(context, id) {
      const response = await http.delete(`order/${id}`)

      return response
    },
    async searchOrders(context, params) {
      const response = await http.get(`order/${requestUrlFunction(params)}`)

      return response
    },
    async searchOrderComments(context, { id, params }) {
      const response = await http.get(`order/${id}/comment/${requestUrlFunction(params)}`)

      return response
    },
    async searchPersonalizedOffers(context, { id, params }) {
      const response = await http.get(
        `order/${id}/personalized-offer/${requestUrlFunction(params)}`
      )

      return response
    },
    async deletePersonalizedOffer(context, { id, offerId }) {
      const response = await http.delete(`order/${id}/personalized-offer/${offerId}`)

      return response
    },
    async createOrderPromoCode(context, { id, giftId, count }) {
      const response = await http.post(`order/${id}/promo-code/?giftId=${giftId}&count=${count}`)

      return response
    },
    async deleteOrderPromoCode(context, { id, promoCodeId }) {
      const response = await http.delete(`order/${id}/promo-code/${promoCodeId}`)

      return response
    },
    async searchOrderPromoCodes(context, { id, params }) {
      const response = await http.get(`order/${id}/promo-code/${requestUrlFunction(params)}`)

      return response
    },
    async sendPromoCodeNotification(context, { id, promoCodeId }) {
      const response = await http.post(`order/${id}/promo-code/${promoCodeId}/notification`)

      return response
    },
    async getOrderDocuments(context, id) {
      const response = await http.get(`order/${id}/signature/document/`)

      return response
    },
    async uploadOrderAttachment(context, { id, name, files }) {
      const formData = new FormData()

      formData.append('name', name)

      if (files) {
        files.forEach((it) => formData.append('files', it))
      }

      const response = await http.post(`order/${id}/attachment`, formData)

      return response
    },
    async deleteOrderAttachment(context, { id, uuid }) {
      const response = await http.delete(`order/${id}/attachment/${uuid}`)

      return response
    },
    async searchOrderAttachments(context, { id, params }) {
      const response = await http.get(`order/${id}/attachment/${requestUrlFunction(params)}`)

      return response
    },
    async searchOrderAuditRevisions(context, { id, params }) {
      const response = await http.get(`order/${id}/audit/revision/${requestUrlFunction(params)}`)

      return response
    },
    async createOrderLabel(context, { id, name, color }) {
      const response = await http.post(`order/${id}/label`, {
        name: name,
        color: color,
      })
      return response
    },
    async deleteOrderLabel(context, { id, labelId }) {
      const response = await http.delete(`order/${id}/label/${labelId}`)

      return response
    },
    async getOrderLabels(context, id) {
      const response = await http.get(`order/${id}/label`)

      return response
    },
  },
}
